import React, { useContext, useState } from "react";
import zohoLogo from "../../images/zoho_logo.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function ZohoButtons({ data }) {
  const [addToZohoPopup, setAddToZohoPopup] = useState(false);
  const [updateToZohoPopup, setUpdateToZohoPopup] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);

  const updateToZohoHandler = () => {
    if (data.summ.length > 2000) {
      Swal.fire({
        icon: "error",
        title: "Summary is more than 2000 characters",
        showConfirmButton: false,
        timer: 1500,
      });
      setUpdateToZohoPopup(false);
      return;
    }
    setUpdateLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}update-to-zoho`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ expert_id: data.id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setUpdateToZohoPopup(false);
        setUpdateLoading(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Expert has been updated to Zoho",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  const addToZohoHandler = () => {
    if (data.summ.length > 2000) {
      Swal.fire({
        icon: "error",
        title: "Summary is more than 2000 characters",
        showConfirmButton: false,
        timer: 1500,
      });
      setUpdateToZohoPopup(false);
      return;
    }
    if (data.email === "email@email.com") {
      Swal.fire({
        icon: "error",
        title: "Invalid Email, please update the email first",
        showConfirmButton: false,
        timer: 1500,
      });
      setAddToZohoPopup(false);
      return;
    }
    setAddLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}add-to-zoho`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ expert_id: data.id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAddToZohoPopup(false);
        setAddLoading(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Expert has been added to Zoho",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  return (
    <>
      {/* {data?.status === "Interested" && data?.in_zoho === "None" && (
        <button
          className="btn addToZohoBtn"
          onClick={() => setAddToZohoPopup(true)}
        >
          <i className="fa-solid fa-user-plus" /> Add to{" "}
          <img
            width="50px"
            src={zohoLogo}
            style={{ marginBottom: "6px" }}
            alt=""
          />
        </button>
      )} */}
      {data?.in_zoho === "yes" ? (
        <button
          className="btn updateToZohoBtn"
          onClick={() => setUpdateToZohoPopup(true)}
        >
          <i className="fa-solid fa-arrow-up-from-bracket" /> Update to{" "}
          <img
            width="50px"
            src={zohoLogo}
            style={{ marginBottom: "6px" }}
            alt=""
          />
        </button>
      ) : (
        <button
          className="btn addToZohoBtn"
          onClick={() => setAddToZohoPopup(true)}
        >
          <i className="fa-solid fa-user-plus" /> Add to{" "}
          <img
            width="50px"
            src={zohoLogo}
            style={{ marginBottom: "6px" }}
            alt=""
          />
        </button>
      )}

      {addToZohoPopup && (
        <div className="addToZoho-popup-wrapper">
          <div className="tab-pane fade show addToZoho-div">
            {!addLoading ? (
              <>
                <div>
                  <center>
                    <img className="image" src={zohoLogo} alt="" />
                    <p>
                      Do you want to add this profile to <strong>Zoho?</strong>
                    </p>
                    <br />
                  </center>
                </div>
                <div>
                  <center>
                    <button
                      className="btn btn-light"
                      onClick={() => setAddToZohoPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      onClick={addToZohoHandler}
                      className="btn base-btn"
                      style={{ marginLeft: "6px" }}
                    >
                      Continue
                    </button>
                  </center>
                </div>
              </>
            ) : (
              <center>
                <p style={{ fontSize: "18px" }}>Adding data...</p>
                <br />
                <img
                  src={LoadingIcon}
                  alt=""
                  style={{ width: "50px", marginRight: "5px" }}
                />
              </center>
            )}
          </div>
        </div>
      )}

      {updateToZohoPopup && (
        <div className="updateToZoho-popup-wrapper">
          <div className="tab-pane fade show updateToZoho-div">
            {!updateLoading ? (
              <>
                <div>
                  <center>
                    <img className="image" src={zohoLogo} alt="" />
                    <p>
                      Do you want to update this profile to{" "}
                      <strong>Zoho?</strong>
                    </p>
                    <br />
                  </center>
                </div>
                <div>
                  <center>
                    <button
                      className="btn btn-light"
                      onClick={() => setUpdateToZohoPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      onClick={updateToZohoHandler}
                      className="btn base-btn"
                      style={{ marginLeft: "6px" }}
                    >
                      Continue
                    </button>
                  </center>
                </div>
              </>
            ) : (
              <center>
                <p style={{ fontSize: "18px" }}>Updating data...</p>
                <br />
                <img
                  src={LoadingIcon}
                  alt=""
                  style={{ width: "50px", marginRight: "5px" }}
                />
              </center>
            )}
          </div>
        </div>
      )}
    </>
  );
}
